import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderManagement from '../../views/multiChannel/OrderManagement';
import { MULTI_CHANNEL_PAGE_NAME } from '../../constants/service/app/multiChannelConstants';

const MultiChannelOrderManagement = () => {
  return (
    <PageTemplate pageName={MULTI_CHANNEL_PAGE_NAME.ORDER_MANAGEMENT}>
      <OrderManagement />
    </PageTemplate>
  );
};

export default MultiChannelOrderManagement;
